import {
  listFormulaCards,
  listFormulaCardTypeMappings,
  getFormulaCard,
  getOvertimeSummary,
  listSalaryComponents,
  listEntries,
  getPreview,
} from './queries';
import {
  createFormulaCard,
  updateFormulaCard,
  updateEntries,
  updateComponent,
  bulkUpdateOtBehaviour,
  deleteFormulaCard,
  createFormulaCardTypeMapping,
} from './mutations';

const queries = {
  getOvertimeSummary,
  listFormulaCards,
  listFormulaCardTypeMappings,
  getFormulaCard,
  listSalaryComponents,
  listEntries,
  getPreview,
};

const mutations = {
  createFormulaCard,
  updateFormulaCard,
  updateEntries,
  updateComponent,
  bulkUpdateOtBehaviour,
  deleteFormulaCard,
  createFormulaCardTypeMapping,
};

export const overtimeApis = {
  queries,
  mutations,
};
